export default function DownloadSection() {
  return (
    <section id="download" className="relative w-full py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20orange%20and%20dark%20abstract%20gradient%20background%20with%20subtle%20sports%20energy%20wave%20patterns%2C%20modern%20digital%20texture%2C%20clean%20minimalist%20design%2C%20athletic%20vibe%2C%20professional%20cinematic%20lighting&width=1800&height=700&seq=download-cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/95 via-primary-800/90 to-primary-900/95"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-extrabold text-white mb-4">
          准备好体验全新的观赛方式了吗？
        </h2>
        <p className="text-base text-white/70 mb-10 max-w-xl mx-auto">
          立即下载大满贯APP安卓版，海量赛事直播、专业数据分析尽在掌握
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <a
            href="#"
            className="w-full sm:w-auto px-10 py-4 rounded-xl bg-white text-primary-700 text-base font-bold hover:bg-primary-50 transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-android-line text-xl"></i>
            Android APK 下载
          </a>
        </div>

        <div className="flex items-center justify-center gap-6 text-white/60 text-sm">
          <span>版本 V5.8.0</span>
          <span className="w-1 h-1 rounded-full bg-white/30"></span>
          <span>大小 48.2 MB</span>
          <span className="w-1 h-1 rounded-full bg-white/30"></span>
          <span>更新日期 2026-08-05</span>
        </div>

        <div className="mt-10 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/10 border border-white/20">
          <i className="ri-shield-check-line text-accent-400"></i>
          <span className="text-white/80 text-sm">官方正版 · 安全无毒 · 通过360安全检测</span>
        </div>
      </div>
    </section>
  );
}